import {combineReducers} from 'redux';
import {handleActions} from 'redux-actions';
import {Map} from 'immutable';

import ActionTypes from './action-types';
import {MealRegistration} from './model';

const mealRegistrationsReducer = handleActions(
    {
        [ActionTypes.MEAL_REGISTRATION_FETCH]: (state, {payload}) => state.merge({[payload.mealRegistrationId]: true}),
        [ActionTypes.MEAL_REGISTRATION_FETCH_SUCCESS]: (state, {payload}) =>
            state.merge({[payload.mealRegistrationId]: MealRegistration.fromAPI(payload.mealRegistration)}),
        [ActionTypes.MEAL_REGISTRATION_FETCH_FAILED]: (state, {payload}) =>
            state.merge({[payload.mealRegistrationId]: false}),
        [ActionTypes.MEAL_REGISTRATION_UPDATE_SUCCESS]: (state, {payload}) =>
            state.merge({[payload.mealRegistration.id]: MealRegistration.fromAPI(payload.updatedMealRegistration)}),
        [ActionTypes.MEAL_REGISTRATION_DELETE_SUCCESS]: (state, {payload}) => state.delete(payload.mealRegistrationId),
    },
    Map(),
);

export default combineReducers({
    mealRegistrations: mealRegistrationsReducer,
});
